'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _isEmpty = require('transmute/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _WidgetActions = require('../actions/WidgetActions');

var _statusComparators = require('conversations-async-data/async-data/operators/statusComparators');

var _handleReceiveWidgetData = require('../widget-data/actions/handleReceiveWidgetData');

var _refreshWidgetData = require('../widget-data/actions/refreshWidgetData');

var _WindowActions = require('../actions/WindowActions');

var _handleIframeResize = require('../post-message/actions/handleIframeResize');

var _handleClosedWelcomeMessage = require('../post-message/actions/handleClosedWelcomeMessage');

var _handleRequestWidget = require('../post-message/actions/handleRequestWidget');

var _handleScrollPercentageChange = require('../scroll-percentage-trigger/actions/handleScrollPercentageChange');

var _handleExitIntent = require('../exit-intent-trigger/actions/handleExitIntent');

var _getIsOpen = require('../selectors/getIsOpen');

var _getIsMobile = require('../selectors/getIsMobile');

var _getWidgetLocation = require('../selectors/widgetDataSelectors/getWidgetLocation');

var _getWidgetDataAsyncData = require('../widget-data/selectors/getWidgetDataAsyncData');

var _trackUserInteraction = require('../actions/trackUserInteraction');

var _Application = require('../components/Application');

var _Application2 = _interopRequireDefault(_Application);

var _preloadThreadHistory = require('../actions/preloadThreadHistory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, _ref) {
  var speedCurveWidgetData = _ref.speedCurveWidgetData;

  var widgetDataAsyncData = (0, _getWidgetDataAsyncData.getWidgetDataAsyncData)(state);
  var shouldRenderContent = (0, _statusComparators.isSucceeded)(widgetDataAsyncData) || !(0, _isEmpty2.default)(speedCurveWidgetData);

  return {
    isOpen: (0, _getIsOpen.getIsOpen)(state),
    mobile: (0, _getIsMobile.getIsMobile)(state),
    shouldRenderContent: shouldRenderContent,
    widgetLocation: (0, _getWidgetLocation.getWidgetLocation)(state)
  };
};

var mapDispatchToProps = {
  handleIframeResize: _handleIframeResize.handleIframeResize,
  handleClosedWelcomeMessage: _handleClosedWelcomeMessage.handleClosedWelcomeMessage,
  handleExitIntent: _handleExitIntent.handleExitIntent,
  handleReceiveWidgetData: _handleReceiveWidgetData.handleReceiveWidgetData,
  handleRequestWidget: _handleRequestWidget.handleRequestWidget,
  handleScrollPercentageChange: _handleScrollPercentageChange.handleScrollPercentageChange,
  onLauncherHover: _preloadThreadHistory.preloadHistory,
  setWindowVisible: _WindowActions.setWindowVisible,
  refreshWidgetData: _refreshWidgetData.refreshWidgetData,
  toggleOpen: _WidgetActions.toggleOpen,
  trackUserInteraction: _trackUserInteraction.trackUserInteraction
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Application2.default);
module.exports = exports['default'];